module.exports = __webpack_public_path__ + "img/100.b9db7c38.jpg";